import ReactGA from 'react-ga'
import * as Font from 'expo-font'
import { AppLoading } from 'expo'
import { Provider } from 'react-redux'
import React, { useState, useEffect } from 'react'
import { ActivityIndicator, View } from 'react-native'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider as PaperProvider } from 'react-native-paper'
import { SafeAreaProvider } from 'react-native-safe-area-context'
import AppNavigator from './src/navigation/AppNavigator'
import { Toast } from './src/components'
import CustomHelmet from './src/components/CustomHelmet'

import { persistor, store } from './src/redux/store'
import { ThemeProvider } from './src/theming/ThemeProvider'
import { AppContainer } from './styles'
import SmartAppBanner from './src/components/SmartAppBanner'
import { isMobileSafari } from './src/tools/platform'

ReactGA.initialize('UA-145980790-2')

const App = () => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-145980790-2'
    script.async = true
    document.body.appendChild(script)
    const secondScript = document.createElement('script')
    secondScript.async = true
    secondScript.textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'UA-145980790-2');
    `
    document.body.appendChild(secondScript)
    return () => {
      document.body.removeChild(script)
      document.body.removeChild(secondScript)
    }
  }, [])

  const loadFonts = async () => {
    await Font.loadAsync({

      'roboto-regular': require('./assets/fonts/Roboto/Roboto-Regular.ttf'),
      'roboto-medium': require('./assets/fonts/Roboto/Roboto-Medium.ttf'),
      'roboto-bold': require('./assets/fonts/Roboto/Roboto-Bold.ttf'),

      'poppins-regular': require('./assets/fonts/Poppins/Poppins-Regular.ttf'),
      'poppins-medium': require('./assets/fonts/Poppins/Poppins-Medium.ttf'),
      'poppins-bold': require('./assets/fonts/Poppins/Poppins-Bold.ttf')

    }).then(() => setLoading(false)
    ).catch(() => setLoading(false)
    )
  }

  return (
    <AppContainer style={{ flex: 1 }}>
      <Provider store={store}>
        <PersistGate loading={<ActivityIndicator />} persistor={persistor}>
          <ThemeProvider>
            <PaperProvider>
              <View style={{ flex: 1, overflowX: 'hidden' }}>
                {loading ? (
                  <AppLoading
                    startAsync={loadFonts}
                    onError={() => console.log('error loading page')}
                    onFinish={() => setLoading(false)}
                  />
                ) : (
                  <SafeAreaProvider>
                    <CustomHelmet />
                    <AppNavigator />
                    {!isMobileSafari() && <SmartAppBanner />}
                  </SafeAreaProvider>)}
                <Toast />
              </View>
            </PaperProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </AppContainer>
  )
}

export default App
console.disableYellowBox = true
